import { useCallback, useRef, useState } from 'react';

export interface Toast {
  id: number;
  message: string;
}

const TOAST_MS = 3500;

/** Short-lived confirmations shown top right. Errors keep their own banner. */
export function useToasts() {
  const [toasts, setToasts] = useState<Toast[]>([]);
  const next = useRef(0);

  const dismiss = useCallback((id: number) => {
    setToasts((list) => list.filter((t) => t.id !== id));
  }, []);

  const toast = useCallback(
    (message: string) => {
      const id = ++next.current;
      setToasts((list) => [...list.slice(-3), { id, message }]);
      window.setTimeout(() => dismiss(id), TOAST_MS);
    },
    [dismiss],
  );

  return { toasts, toast, dismiss };
}
